import { Button, Td, Tr } from "@chakra-ui/react";
import {
  deleteImportRequest,
  downloadDataImportFile,
  ImportRequestModel,
  ImportRequestState,
} from "../../clients/BackOfficeApi";
import { LinkButton } from "../../elements/LinkButton";
import { DeleteIcon, DownloadIcon } from "@chakra-ui/icons";
import { useCallback, useMemo } from "react";
import { ActionButton } from "../../elements/ActionButton";
import { FormattedDate, FormattedMessage } from "react-intl";

interface Props {
  importRequest: ImportRequestModel;
  onChange?: () => void;
}
export function ImportRequestListRow({ importRequest, onChange }: Props) {
  const fileReferenceId = useMemo(
    () => importRequest.fileReferenceId,
    [importRequest],
  );

  const downloadFile = useCallback(
    () =>
      downloadDataImportFile({
        path: { fileReferenceId },
        throwOnError: true,
      }).then(({ data }) => {
        if (data instanceof Blob || data instanceof MediaSource) {
          const url = window.URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", importRequest.filename);
          document.body.appendChild(link);
          link.click();
          link.parentNode?.removeChild(link);
          window.URL.revokeObjectURL(url);
        }
      }),
    [fileReferenceId, importRequest.filename],
  );

  const handleDelete = useCallback((confirmed: boolean) => {
    if (!confirmed) return;

    deleteImportRequest({
      path: { importRequestId: importRequest.id },
      throwOnError: true,
    }).finally(() => onChange?.());
  }, [importRequest.id, onChange]);

  return (
    <Tr>
      <Td>
        <LinkButton to={importRequest.id.toString()}>
          {importRequest.id}
        </LinkButton>
      </Td>
      <Td>
        <Button onClick={downloadFile} variant="link">
          {importRequest.filename} <DownloadIcon ml={2} />
        </Button>
      </Td>
      <Td><FormattedMessage defaultMessage={importRequest.status} id={`importRequest.state.${importRequest.status}`} /></Td>
      <Td><FormattedMessage defaultMessage={importRequest.mode} id={`importRequest.mode.${importRequest.mode}`} /></Td>
      <Td><FormattedDate dateStyle="long" timeStyle="short" value={importRequest.creationDateTime} /></Td>
      <Td>{importRequest.result && <FormattedMessage defaultMessage={importRequest.result} id={`importReport.state.${importRequest.result}`} />}</Td>
      <Td>
        {!!importRequest.reportId && (
          <LinkButton to={`${importRequest.id}/report`}>Rapport</LinkButton>
        )}
      </Td>
      <Td>
        {importRequest.status !== ImportRequestState.PENDING && (
          <ActionButton
            color="red.500"
            confirmDescription="Weet je zeker dat je dit importeerverzoek wilt verwijderen? Deze actie kan niet ongedaan gemaakt worden."
            confirmTitle="Verwijderen bevestigen"
            icon={<DeleteIcon />}
            isDestructive
            onClick={handleDelete}
            title="Verwijderen"
            variant="link"
          />
        )}
      </Td>
    </Tr>
  );
}
